import { javaTrim } from './javaCompat';

/** Field names in templates and in SQL results differ only by case in practice. */
const key = (s) => javaTrim(String(s)).toLowerCase();

/**
 * The flat row set a template is bound to (port of Fr3Data).
 *
 * Every template binds a single dataset (DM1.PrintQ) and reads a
 * denormalised result where master and detail live on the same row, so one
 * list of rows is the whole data model. Values are strings or null.
 */
export class Fr3Data {
    constructor() {
        this.rows = [];
        this.variables = new Map();
    }

    /** rows: [{ name: value }] or [Map]. */
    static of(rows) {
        const d = new Fr3Data();
        if (rows) rows.forEach((r) => d.addRow(r));
        return d;
    }

    addRow(row) {
        const norm = new Map();
        if (row) {
            const entries = row instanceof Map ? row.entries() : Object.entries(row);
            for (const [k, v] of entries) {
                if (k == null) continue;
                norm.set(key(k), v === undefined ? null : v);
            }
        }
        this.rows.push(norm);
        return this;
    }

    setVariable(name, value) {
        if (name != null) this.variables.set(key(name), value);
        return this;
    }

    rowCount() { return this.rows.length; }

    isEmpty() { return this.rows.length === 0; }

    field(rowIndex, name) {
        if (rowIndex < 0 || rowIndex >= this.rows.length) return null;
        const v = this.rows[rowIndex].get(key(name));
        return v === undefined ? null : v;
    }

    hasField(name) {
        const k = key(name);
        return this.rows.some((r) => r.has(k));
    }

    variable(name) {
        const v = this.variables.get(key(name));
        return v === undefined ? null : v;
    }

    hasVariable(name) {
        return this.variables.has(key(name));
    }
}

export default Fr3Data;
